import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "mdb_dash_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API, timeout: 20000 });

api.interceptors.request.use((c) => {
  const t = getToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const isAdmin = !!e.config?.headers?.["X-Admin-Password"];
    if (e.response?.status === 401 && !isAdmin && getToken()) {
      setToken(null);
      window.dispatchEvent(new Event("mdb-logout"));
    }
    return Promise.reject(e);
  }
);

export const admin = (pw) => ({ headers: { "X-Admin-Password": pw } });

export const errMsg = (e) =>
  e?.response?.data?.message || e?.response?.data?.detail?.message || e?.response?.data?.detail || e?.message || "Request failed";

export const get = (url, params) => api.get(url, { params }).then((r) => r.data);
